import React from 'react'
import {useTranslation} from "react-i18next";
import {useFormik} from "formik";
import * as yup from "yup";

import {useCreateGroup} from "../query";
import WorkgroupsAutocomplete from "../../../components/inputs/WorkgroupsAutocomplete";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import MDInput from "../../../materialDashboard/components/MDInput";

import MDBox from "../../../materialDashboard/components/MDBox";
import MDTypography from "../../../materialDashboard/components/MDTypography";
import MDButton from "../../../materialDashboard/components/MDButton";


const GroupCreate = () => {
    const {t} = useTranslation(['groups', 'validation']);

    const userMutation = useCreateGroup();

    const formik = useFormik({
        initialValues: {
            name: "",
            workgroups: [],
        },
        validationSchema: yup.object({
            name: yup
                .string()
                .required(t('validation:required')),
            workgroups: yup
                .array()
                .required(t('validation:required'))
                .min(1, t('validation:minArray', {min: 1}))
                .max(1, t('validation:maxArray', {max: 1}))
        }),
        onSubmit: async (values) => {
            const {workgroups, passwordConfirmation, ...rest} = values;
            const workgroupId = workgroups[0].id;
            await userMutation.mutateAsync({...rest, workgroupId: workgroupId});
        }
    });

    return <Grid container justifyContent="center" alignItems="center" mt={4}>
        <Grid item xs={12} lg={8}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    coloredShadow="info"
                    mx={2}
                    mt={-3}
                    p={2}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        {t('groupCreate.title')}
                    </MDTypography>
                </MDBox>

                <Stack direction="column" spacing={3} p={3}>
                    <MDBox>
                        <Grid container spacing={2} mb={2}>
                            <Grid item xs={12} lg={6}>
                                <MDInput name="name"
                                         label={t('groupCreate.name')}
                                         value={formik.values.name}
                                         onChange={formik.handleChange}
                                         error={formik.touched.name && Boolean(formik.errors.name)}
                                         helperText={formik.touched.name && formik.errors.name}
                                         variant="standard"
                                         fullWidth
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <WorkgroupsAutocomplete selectedWorkgroups={formik.values.workgroups}
                                                        setSelectedWorkgroups={value => formik.setFieldValue('workgroups', value)}
                                                        workgroupFilters={{
                                                            acl__users_write: true
                                                        }}
                                                        fieldProps={
                                                            {
                                                                error: formik.touched.workgroups && Boolean(formik.errors.workgroups),
                                                                helperText: formik.touched.workgroups && formik.errors.workgroups,
                                                            }
                                                        }/>
                            </Grid>
                        </Grid>
                    </MDBox>

                    <Stack justifyContent="flex-end">
                        <MDButton variant="gradient" color="info" onClick={formik.handleSubmit} sx={{ml: "auto"}}>
                            {t('groupCreate.submit')}
                        </MDButton>
                    </Stack>

                </Stack>
            </Card>
        </Grid>
    </Grid>
}

export default GroupCreate;